import { z } from "zod/mini"

import { GeoPointLegacySchema } from "./legacy/geopoint"

export const GeoPointContentType = "GeoPointContent" as const

export const GeoPointContentSchema = z.extend(GeoPointLegacySchema, {
	__TYPE__: z.literal(GeoPointContentType),
})

export type GeoPointContent = z.infer<typeof GeoPointContentSchema>
